import { render } from "./AktuellesEdit.vue?vue&type=template&id=a08bce9c"
import script from "./AktuellesEdit.vue?vue&type=script&lang=js"
export * from "./AktuellesEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__